import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <>
      <h1>ErrorPage</h1>
      <Link to="/"> Go Back</Link>
    </>
  );
};

export default ErrorPage;
